/**
 * @type {string}
 * @description - The AI server on maintenance web component.
 */
export const AI_SERVER_ON_MAINTENANCE_WEB_COMPONENT =
    'ai-server-on-maintenance-component';

/**
 * Maintenance AI server options.
 * @type {{
 *  OFFLINE: string,
 *  MAINTENANCE: string,
 *  ONLINE: string,
 * }}
 */
export const MAINTENANCE_AI_SERVER_OPTIONS = {
    OFFLINE: 'offline',
    MAINTENANCE: 'maintenance',
    ONLINE: 'online',
};

/**
 * Maintenance AI server current state.
 * @type {string}
 */
export const MAINTENANCE_AI_SERVER_CURRENT_STATE = MAINTENANCE_AI_SERVER_OPTIONS.ONLINE;
